// extracted by mini-css-extract-plugin
export default {"container":"ufxFrm1Eyg-kKZ7biRynqQ==","switcher":"o1FOBAF4OLcKCGWYz8Y15A==","on":"dixbXEeGS-LtVjr4yR7QeA=="};